/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CreateFabricTableShortcutDemoResponseResultsInner {
  /**
  * The name of the Fabric table shortcut
  */
  'name': string;
  /**
  * Whether the shortcut was created successfully
  */
  'success': boolean;
  /**
  * Error message if the creation failed (only present when success is false)
  */
  'error'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "success",
      "baseName": "success",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "error",
      "baseName": "error",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateFabricTableShortcutDemoResponseResultsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

